import { createRef, Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import emptyFunction from 'react-utils/emptyFunction';
import { generatePath, withRouter } from 'react-router-dom';
import UIFlowCanvas from 'automation-ui-canvas/components/canvas/UIFlowCanvas';
import { getBranchIndex, getPreviousActionId } from 'automation-ui-action-features/records/recordsUtils';
import * as CanvasIdentifiers from 'automation-ui-flow-core/canvas/CanvasIdentifiers';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import { queryAllExtensionDefinitions } from 'automation-ui-action-features/actions/extension/extensionQueries';
import { parseLocation } from 'automation-ui-routing/utils';
import { basePaths } from 'automation-ui-canvas/constants/Routes';
import MinimapFlowCanvas from 'automation-ui-canvas/components/canvas/MinimapFlowCanvas';
import { getIsCanvasVirtualRenderingDisabled } from 'automation-ui-canvas/selectors/platformFlowsApplicationSelectors';
import { getActionHeaderTitle, getActionOutputsForTargetActionById, getObjectTypeId, getSourceApp } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { wireActionOutputs } from 'automation-ui-action-features/queries/actionOutputQueries';
import BranchName from 'automation-ui-canvas/components/canvas/BranchName';
import EndMarker from 'automation-ui-canvas/components/common/EndMarker';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import { EDIT_ACTIONS, EDIT_ENROLLMENT } from 'automation-ui-permissions/feature-permissions/constants/WorkflowManagementFeatures';
import { withFeaturePermissions } from 'automation-ui-permissions/feature-permissions/decorators/FeaturePermissionsDecorator';
import FlowCanvasNode from 'automation-ui-canvas/components/canvas/FlowCanvasNode';
import { buildSearchStringWithCurrentSourceFields, isActionConfigOpen } from 'automation-ui-canvas/utils/routingUtils';
import { CARD_WIDTH, CARD_WIDTH_PADDING, CARD_HEIGHT, EMBEDDED_CARD_HEIGHT } from 'automation-ui-flow-core/canvas/graphConstants';
import { PLATFORM_ACTION_EDIT, STATIC_BRANCH_ACTION_EDIT } from 'automation-ui-canvas/constants/AbsolutePaths';
import { getScreenForFlowType } from 'automation-ui-canvas/utils/getScreenForFlowType';
import withFlpAccess from 'automation-ui-permissions/flp/hocs/withFlpAccess';
import BranchLabel from 'automation-ui-canvas/components/canvas/BranchLabel';
import BranchDescription from 'automation-ui-canvas/components/canvas/BranchDescription';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCanvas = styled.div.withConfig({
  displayName: "FlowCanvasBase__StyledCanvas",
  componentId: "mb9ztt-0"
})(["height:100%;"]);
const StyledRoot = styled.div.withConfig({
  displayName: "FlowCanvasBase__StyledRoot",
  componentId: "mb9ztt-1"
})(["height:100%;.", "{", ";}.", "{", ";}"], CanvasIdentifiers.ADD_BUTTON_CONTAINER, ({
  isEmbedded
}) => isEmbedded ? 'padding: 25px !important' : null, CanvasIdentifiers.EMPTY_CONTENT_CARD, ({
  isEmbedded
}) => isEmbedded ? 'margin: 0 !important' : null);
const defaultProps = {
  isEmbedded: false,
  isMulti: false,
  readOnlyOverride: false,
  columnWidth: 260,
  onSelectAction: emptyFunction,
  ComposedCanvas: StyledCanvas,
  goToHoverNode: {},
  showOuterPadding: true,
  showEdgeTooltips: false,
  showEnrollmentCard: true,
  centerOnMount: true
};
class FlowCanvasBase extends Component {
  constructor(...args) {
    super(...args);
    this.didCenterOnMount = false;
    this.rootZoomableNodeRef = /*#__PURE__*/createRef();
    this.setScrollLeft = () => {
      const {
        canvasScrollElementRef,
        centerOnMount
      } = this.props;
      const scrollContainer = canvasScrollElementRef && canvasScrollElementRef.current;
      if (scrollContainer && centerOnMount) {
        scrollContainer.scrollLeft = (scrollContainer.scrollWidth - scrollContainer.offsetWidth) / 2;
        this.didCenterOnMount = true;
      }
    };
    this.handleClickBranchLabel = edgeId => {
      const {
        history,
        flow,
        location
      } = this.props;
      const actionId = getPreviousActionId(edgeId);
      const action = flow.getActionById(actionId);
      const branchIndex = getBranchIndex(edgeId);
      let path;
      const screen = getScreenForFlowType(flow.flowType);
      let queryParams;

      // TODO: add case for loops?
      if (action.isListBranch()) {
        const actionType = basePaths.PLATFORM_FLOW_LIST_BRANCH_ACTION;
        path = generatePath(PLATFORM_ACTION_EDIT, {
          flowId: flow.getFlowId(),
          screen,
          actionId,
          configRoute: actionType
        });
        queryParams = {
          activeBranch: branchIndex
        };
      } else if (action.isStaticBranch()) {
        path = generatePath(STATIC_BRANCH_ACTION_EDIT, {
          flowId: flow.getFlowId(),
          screen,
          actionId
        });
      }
      const search = buildSearchStringWithCurrentSourceFields({
        location,
        queryParams
      });
      history.replace({
        pathname: path,
        search
      });
    };
    this.handleGetActionOutputsForTargetActionById = (targetActionId, isNew) => getActionOutputsForTargetActionById({
      flow: this.props.flow,
      allOutputsByActionTypeId: this.props.allOutputsByActionTypeId,
      instanceOutputsByActionId: this.props.instanceOutputsByActionId,
      targetActionId,
      isNewAction: isNew
    });
    this.onRenderBranchName = edgeId => {
      const {
        flow,
        zoomLevel
      } = this.props;
      return /*#__PURE__*/_jsx(BranchLabel, {
        zoomLevel: zoomLevel,
        branchLabelHeaderText: /*#__PURE__*/_jsx(BranchName, {
          flow: flow,
          edgeId: edgeId,
          handleGetActionOutputsForTargetActionById: this.handleGetActionOutputsForTargetActionById
        }),
        branchDescription: /*#__PURE__*/_jsx(BranchDescription, {
          flow: flow,
          edgeId: edgeId
        })
      });
    };
    this.onRenderEndMarker = ({
      edgeId
    }) => {
      const {
        zoomLevel,
        flow
      } = this.props;
      return /*#__PURE__*/_jsx(EndMarker, {
        flow: flow,
        edgeId: edgeId,
        zoomLevel: zoomLevel
      });
    };
    this.onRenderCanvasNode = ({
      id,
      width,
      height
    }) => {
      const {
        flow,
        getFeaturePermission,
        readOnlyOverride,
        onSelectAction,
        isMulti,
        flpAccessLoading,
        flpAccessData,
        flpAccessError,
        zoomLevel
      } = this.props;
      if (!flow || flpAccessLoading) {
        return null;
      }
      let readOnly = readOnlyOverride;
      const hasFlpWriteAccess = !flpAccessError && (flpAccessData === null || flpAccessData === void 0 ? void 0 : flpAccessData.hasAccess(EDIT_ENROLLMENT));
      if (id === SpecialActionIds.ENROLLMENT) {
        const {
          hasFeatureAccess: hasEditEnrollmentAccess
        } = getFeaturePermission({
          feature: EDIT_ENROLLMENT
        });
        readOnly = !hasEditEnrollmentAccess || readOnlyOverride;
      } else if (id === CanvasIdentifiers.VIRTUAL_ANCHORED_DELAY_NODE) {
        readOnly = true;
      } else {
        const {
          hasFeatureAccess: hasEditActionAccess
        } = getFeaturePermission({
          feature: EDIT_ACTIONS
        });
        readOnly = !hasEditActionAccess || readOnlyOverride;
      }
      readOnly || (readOnly = !hasFlpWriteAccess);
      return /*#__PURE__*/_jsx(FlowCanvasNode, {
        id: id,
        width: width,
        height: height,
        flow: flow,
        readOnly: readOnly,
        showIcon: !isMulti,
        onSelectNode: onSelectAction,
        getActionOutputsForTargetActionById: this.handleGetActionOutputsForTargetActionById,
        zoomLevel: zoomLevel
      });
    };
    this.handleSettingFirstNodeRef = () => {
      if (!this.rootZoomableNodeRefIsSet && this.rootZoomableNodeRef.current) {
        this.forceUpdate();
        this.rootZoomableNodeRefIsSet = true;
      }
    };
  }
  componentDidMount() {
    this.setScrollLeft();
  }
  componentDidUpdate() {
    if (!this.didCenterOnMount && this.props.centerOnMount && this.props.flow) {
      this.setScrollLeft();
      this.didCenterOnMount = true;
    }
  }

  /**
   * Since ref forwarding does not alert of changes to the DOM
   * element, we must force update the component once we receive
   * a valid element.
   */

  render() {
    var _allExtensionDefiniti, _allExtensionDefiniti2;
    const {
      flow,
      isEmbedded,
      isUngated,
      columnWidth,
      canvasScrollElementRef,
      highlightedActionIds,
      location,
      TopContent,
      onRenderCanvasNode,
      onRenderBranchName,
      onRenderEndMarker,
      BottomContent,
      ComposedCanvas,
      goToHoverNode,
      showOuterPadding,
      goToEditNodeId,
      selectedGoToActionId,
      isMulti,
      flowValidation,
      readOnlyOverride,
      showEdgeTooltips,
      isCanvasVirtualRenderingDisabled,
      allExtensionDefinitionsQuery,
      onRenderConnectorButton,
      showEnrollmentCard,
      highlightedEdgeThickness,
      highlightedEdgeColor,
      getIsBranchEdgeHighlighted,
      disableMinimap
    } = this.props;
    if (!flow) {
      return null;
    }
    const isLeftHandPanelEnabled = !isEmbedded;
    const showMinimapFlowCanvas = !disableMinimap && !isEmbedded && !(isLeftHandPanelEnabled && isActionConfigOpen(location));
    const nodeWidth = isEmbedded && isMulti ? Math.min(columnWidth - CARD_WIDTH_PADDING * 2, CARD_WIDTH) : CARD_WIDTH;
    const nodeHeight = nodeWidth < CARD_WIDTH ? EMBEDDED_CARD_HEIGHT : CARD_HEIGHT;
    const extensionDefinitions = (_allExtensionDefiniti = (_allExtensionDefiniti2 = allExtensionDefinitionsQuery.data) === null || _allExtensionDefiniti2 === void 0 ? void 0 : _allExtensionDefiniti2.allExtensionDefinitions) !== null && _allExtensionDefiniti !== void 0 ? _allExtensionDefiniti : {};
    return /*#__PURE__*/_jsxs(StyledRoot, {
      isEmbedded: isEmbedded,
      "data-test-id": "flow-canvas-container",
      children: [canvasScrollElementRef && showMinimapFlowCanvas ? /*#__PURE__*/_jsx(MinimapFlowCanvas, {
        flow: flow,
        canvasScrollElementRef: canvasScrollElementRef || {
          current: null
        },
        flowValidation: flowValidation,
        handleGetActionOutputsForTargetActionById: this.handleGetActionOutputsForTargetActionById,
        getHeaderTitle: getActionHeaderTitle({
          flow,
          extensionDefinitions,
          isUngated
        }),
        nodeWidth: nodeWidth,
        nodeHeight: nodeHeight,
        extensionDefinitions: extensionDefinitions
      }) : null, /*#__PURE__*/_jsxs(ComposedCanvas, {
        "data-test-id": "flow-canvas"
        // @ts-expect-error default value of div doesn't contain rootZoomableNodeRef
        ,
        rootZoomableNodeRef: this.rootZoomableNodeRef,
        scrollElementRef: canvasScrollElementRef,
        children: [/*#__PURE__*/_jsx(UIFlowCanvas, {
          flow: flow,
          isMulti: isMulti,
          scrollElementRef: canvasScrollElementRef,
          firstNodeRef: this.rootZoomableNodeRef,
          setFirstNodeRef: this.handleSettingFirstNodeRef,
          onRenderAction: onRenderCanvasNode || this.onRenderCanvasNode,
          onRenderBranchName: onRenderBranchName || this.onRenderBranchName,
          onRenderEndMarker: onRenderEndMarker || this.onRenderEndMarker,
          onRenderConnectorButton: onRenderConnectorButton,
          highlightedActionIds: highlightedActionIds,
          goToHoverNode: goToHoverNode,
          goToEditNodeId: goToEditNodeId,
          selectedGoToActionId: selectedGoToActionId,
          showOuterPadding: showOuterPadding,
          readOnlyOverride: readOnlyOverride,
          TopContent: TopContent,
          disableVirtualRendering: isCanvasVirtualRenderingDisabled,
          showEdgeTooltips: showEdgeTooltips,
          nodeWidth: nodeWidth,
          nodeHeight: nodeHeight,
          showEnrollmentCard: showEnrollmentCard,
          highlightedEdgeThickness: highlightedEdgeThickness,
          highlightedEdgeColor: highlightedEdgeColor,
          getIsBranchEdgeHighlighted: getIsBranchEdgeHighlighted
        }), BottomContent]
      })]
    });
  }
}
FlowCanvasBase.defaultProps = defaultProps;
const mapStateToProps = (state, ownProps) => {
  const {
    location,
    overrideParams = {},
    flowId,
    isMulti
  } = ownProps;
  const parsedQuery = parseLocation(location);
  let edgeId = parsedQuery.edgeId;
  const activeFlowId = Number(overrideParams.flowId || parsedQuery.activeFlowId);
  if (isMulti && activeFlowId !== flowId) {
    edgeId = null;
  }
  return {
    edgeId,
    isCanvasVirtualRenderingDisabled: getIsCanvasVirtualRenderingDisabled(state)
  };
};
export default compose(withFeaturePermissions, withFlpAccess, withRouter, wireAuthConsumer, connect(mapStateToProps), WrappedComponent => props => wireActionOutputs(WrappedComponent, {
  flow: props.flow
})(props), WrappedComponent => props => {
  const {
    flow
  } = props;
  const flowObjectTypeId = getObjectTypeId(flow); // for queryAllExtensionDefinitions
  const flowSourceApp = getSourceApp(flow); // for queryAllExtensionDefinitions
  return (
    /*#__PURE__*/
    // @ts-expect-error doesn't think flowObjectId and flowSourceApp are compatible
    // genuinely no clue why
    _jsx(WrappedComponent, Object.assign({}, props, {
      flowObjectTypeId: flowObjectTypeId,
      flowSourceApp: flowSourceApp
    }))
  );
}, queryAllExtensionDefinitions // Requires flowSourceApp and flowObjectTypeId
)(FlowCanvasBase);